const myProjects = [
    {
        name: "TakeCare!",
        description: "TakeCare is a web social application where you can express your emotions about your animal-family-members",
        info: "TakeCare is a web social application where you can express your emotions about your animal-family-members as you could do on a normal social media but more focused on animals. Lets talk about your loved pets! Do you have any question about any strange behavior on your best friend? Maybe someone in the community can help you, filter using your pet race and ask!",
        techUsed: ['fab fa-react', 'fas fa-database', 'fab fa-node', 'fab fa-js', 'fab fa-sass', 'fab fa-bootstrap'],
        projectImg: "/img/wolfdog.jpg",
        externalUrl: "https://takecare-socialapp.herokuapp.com/",
        slug: "take-care",
    },
    {
        name: "Clicasa",
        description: "The test I did to enter Proun, a simple singlepage website.",
        info: "The test I did to enter Proun, a simple singlepage website with some effects.",
        techUsed: ['fab fa-js', 'fab fa-html5', 'fab fa-sass', 'fab fa-bootstrap'],
        projectImg: "/img/projects/clicasa.png",
        externalUrl: "https://clicacasa.netlify.app/",
        slug: "clicasa",
    },
    {
        name: "This is Med",
        description: "A Full-Stack Web Application, I've help on the Front-End part.",
        info: "A Full-Stack Web Application, I've help on the Front-End part, doing most of the web layout from a designer's design, the styles and some of the effects",
        techUsed: ['fab fa-js', 'fab fa-html5', 'fab fa-sass', 'fab fa-bootstrap', 'fab fa-laravel'],
        projectImg: "/img/projects/this-is-med.png",
        externalUrl: "http://thisismed.com/",
        slug: "this-is-med",
    },
    {
        name: "Exercise Tracker",
        description: "An very basic exercise tracker app made using the 'MERN' stack.",
        info: "An very basic exercise tracker app made using the 'MERN' (MongoDB, Express, ReactJS and NodeJS) stack. Just for learning and fun :).",
        techUsed: ['fas fa-database','fab fa-react', 'fab fa-node', 'fab fa-js', 'fab fa-html5', 'fab fa-sass', 'fab fa-bootstrap'],
        projectImg: "/img/projects/exercise-tracker.png",
        projectGif: "/screencasts/projects/exercise-tracker.gif",
        slug: "exercise-tracker",
    },
    {
        name: "Random Quotes",
        description: "A random quote generator with Final Fantasy quotes.",
        info: "A random quote generator with Final Fantasy quotes. Made for FreeCodeCamp 'Front-End Libraries Certification'. It's function is simple, you can press a button called 'Change Quote' to get a new quote, or you can 'tweet it' with the 'twitter' button.",
        techUsed: ['fab fa-react', 'fab fa-js', 'fab fa-html5', 'fab fa-sass', 'fab fa-bootstrap'],
        projectImg: "/img/projects/random-quotes.png",
        slug: "random-quotes",
        externalUrl: "https://codepen.io/Lightark/full/eYpWowg",
    },
    {
        name: "Text Markdown",
        description: "A text markdown previewer, write text and it will be converter to html code.",
        info: "A text markdown previewer, write text and it will be converter to html code.",
        techUsed: ['fab fa-react', 'fab fa-js', 'fab fa-html5', 'fab fa-sass', 'fab fa-bootstrap'],
        projectImg: "/img/projects/markdown-preview.png",
        slug: "text-markdown",
        externalUrl: "https://codepen.io/Lightark/full/zYvzOKP",
    },
    {
        name: "Drum machine",
        description: "A Drum machine, let's compose some music!",
        info: "A Drum machine, let's compose some music!",
        techUsed: ['fab fa-react', 'fab fa-js', 'fab fa-html5', 'fab fa-sass', 'fab fa-bootstrap'],
        projectImg: "/img/projects/drum-machine.png",
        slug: "drum-machine",
        externalUrl: "https://codepen.io/Lightark/full/zYvzOKP",
    },
    {
        name: "Technical Documentation",
        description: "A single page of JS documentation with sidebar",
        info: "A single page of JS documentation with sidebar",
        techUsed: ['fab fa-html5', 'fab fa-css3-alt'],
        projectImg: "/img/projects/technical-documentation.png",
        slug: "technical-documentation",
        externalUrl: "https://codepen.io/Lightark/full/yLBzmOY",
    },
    {
        name: "Rep solar",
        description: "One of the projects I did during my IndianWebs' internship",
        info: "One of the projects I did during my IndianWebs' internship. (It can maybe change by the time you see this)",
        techUsed: ['fab fa-html5', 'fab fa-css3-alt', 'fab fa-wordpress'],
        projectImg: "/img/projects/rep-solar.png",
        slug: "rep-solar",
        externalUrl: "https://rep-solar.com/",
    },
    {
        name: "Survey Form",
        description: "A short form about some videogames...",
        info: "A short form about some videogames...",
        techUsed: ['fab fa-html5', 'fab fa-css3-alt'],
        projectImg: "/img/projects/survey-form.png",
        slug: "survey-form",
        externalUrl: "https://codepen.io/Lightark/full/RwbZqVQ",
    },
    {
        name: "My first Project",
        description: "A short project about my boyfriend who teached me about web development.",
        info: "A short project about my handsome boyfriend who teached me about web development. Maybe that's why I really love web development?",
        techUsed: ['fab fa-html5', 'fab fa-css3-alt'],
        projectImg: "/img/projects/first-project.png",
        slug: "first-project",
        externalUrl: "/Pag2/hey.html",
    },
];

export default myProjects;